import {ActivityLog} from '../types';

const coerceValue = (raw: unknown): number | undefined => {
    if (raw === undefined || raw === null || raw === '') return undefined;
    const n = typeof raw === 'number' ? raw : Number(raw);
    return Number.isFinite(n) ? n : undefined;
};

// Builds the variables payload for the createActivityLog mutation. Whitelists
// the fields declared on backend CreateActivityLogInput (activity-logs.graphql)
// so that frontend-only fields and server-managed fields (id, updated, user)
// cannot leak into the mutation variables. See FNP-36.
export const buildCreateActivityLogInput = (values: ActivityLog): Record<string, unknown> => {
    const input: Record<string, unknown> = {
        username: values.username,
        usageType: values.usageType,
        action: values.action,
        recordId: values.recordId,
    };
    const value = coerceValue(values.value);
    if (value !== undefined) input.value = value;
    if (values.recordType !== undefined) input.recordType = values.recordType;
    input.created = values.created ?? new Date().toISOString();
    return input;
};

// Builds the variables payload for the updateActivityLog mutation. Mirrors the
// create whitelist; UpdateActivityLogInput does not accept recordType, so we
// drop it. id is required by UpdateActivityLogInput.
export const buildUpdateActivityLogInput = (values: ActivityLog): Record<string, unknown> => {
    const input: Record<string, unknown> = {
        id: values.id,
        username: values.username,
        usageType: values.usageType,
        action: values.action,
        recordId: values.recordId,
    };
    const value = coerceValue(values.value);
    if (value !== undefined) input.value = value;
    if (values.updated !== undefined) input.updated = values.updated;
    return input;
};
